import { clsx } from 'clsx';

/** Lightweight className joiner (no tailwind-merge in legacy). */
export function cn(...inputs) {
  return clsx(inputs);
}
